"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Text: true
};
exports.Text = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Theme = require("../Theme");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Text = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    as,
    children,
    variant = "body",
    className,
    ...props
  } = _ref;
  const Component = as || "div";
  const {
    theme: {
      text: textTheme
    }
  } = (0, _Theme.useThemeConfig)();
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
    className: (0, _classnames.default)(textTheme[variant], className),
    ref: ref
  }), children);
});
exports.Text = Text;
Text.displayName = "Typography";